// Add event listener for scroll, swipe and screen resize.
$(window).on('resize scroll', function () {
  if (window.location.href.indexOf('/service') !== -1) {
    // Grab all elements with '.section__services--trigger' class and apply a forEach loop to all of them.
    $('.section__services--trigger').each(function () {
      // check if the selected element is in the viewport.
      if ($(this).isInViewport()) {
        // create a constant to hold the data-trigger value as a string.
        const id = $(this).data('trigger')
        // Grab the active item in the services navigation menu and removes the active class.
        $('.nav__services-item').removeClass('active')
        // Adds active class to the element corresponding the section that is in the viewport.
        $("[data-section='" + id + "']").addClass('active')
      }
    })

    // Still using the scroll listener, verify if the services wrapper element is in the viewport.
    if ($('.section__services').isInViewport()) {
      // Make nav appear if true
      $('.nav__services-pointer-holder').addClass('active')
    } else {
      // Make it disappear if false.
      $('.nav__services-pointer-holder').removeClass('active')
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/_showQANav.js